import { render, staticRenderFns } from "./PopupDelete.vue?vue&type=template&id=702fb975&scoped=true&"
import script from "./PopupDelete.vue?vue&type=script&lang=ts&"
export * from "./PopupDelete.vue?vue&type=script&lang=ts&"
import style0 from "./PopupDelete.vue?vue&type=style&index=0&id=702fb975&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "702fb975",
  null
  
)

export default component.exports